import React from 'react';
import { ClusterPageTemplate } from '../components/ClusterPageTemplate';
export function ClusterTandartsPage() {
  return <ClusterPageTemplate clusterName="Tandarts" sectorName="Zorgpraktijken" sectorSlug="zorgpraktijken" heroTitle="Website laten maken voor een tandartspraktijk" heroDescription="Een geruststellende, professionele website voor jouw mondzorgpraktijk. Wij bouwen websites die nieuwe patiënten aantrekken en informeren." websiteOnderdelen={[{
    icon: 'HeartPulseIcon',
    title: 'Behandelingen',
    description: 'Duidelijke uitleg over preventie, mondhygiëne, implantaten, facings en andere behandelingen.'
  }, {
    icon: 'UsersIcon',
    title: 'Praktijk & Team',
    description: 'Laat de moderne praktijkruimtes zien en stel de tandartsen en assistenten voor om angst weg te nemen.'
  }, {
    icon: 'CalendarCheckIcon',
    title: 'Inschrijven & Afspraken',
    description: 'Een veilige module voor nieuwe patiënten om zich in te schrijven en voor bestaande patiënten om afspraken te maken.'
  }, {
    icon: 'PhoneIcon',
    title: 'Spoed & Pijnklachten',
    description: 'Een direct zichtbare sectie voor spoedgevallen buiten openingstijden.'
  }]} functionaliteiten={[{
    icon: 'ShieldCheckIcon',
    title: 'Veilige inschrijfformulieren',
    description: 'AVG-proof formulieren voor het veilig verzamelen van patiëntgegevens en medische historie.'
  }, {
    icon: 'CalendarCheckIcon',
    title: 'Software koppeling',
    description: 'Integratie met tandheelkundige software zoals Exquise, Simplex of Novadent.'
  }, {
    icon: 'FileTextIcon',
    title: 'Tarievenmodule',
    description: 'Een overzichtelijke weergave van de actuele KNMT-tarieven en vergoedingen.'
  }]} siblingClusters={[{
    name: 'Fysiotherapie',
    slug: 'fysiotherapie'
  }, {
    name: 'Huisarts',
    slug: 'huisarts'
  }, {
    name: 'Psycholoog',
    slug: 'psycholoog'
  }]} faqs={[{
    q: 'Kunnen nieuwe patiënten zich online inschrijven?',
    a: 'Ja, we bouwen veilige, AVG-conforme inschrijfformulieren waarmee nieuwe patiënten direct hun gegevens veilig kunnen doorgeven.'
  }, {
    q: 'Koppelen jullie met Exquise of andere tandartssoftware?',
    a: "We kunnen de web-modules van bekende tandheelkundige softwarepakketten (zoals webagenda's) naadloos integreren in het design van de website."
  }, {
    q: 'Wat kost een website voor een tandartspraktijk?',
    a: 'Een professionele website voor mondzorg start vanaf €1.500. Voor grotere praktijken met veel specialisaties maken we een offerte op maat.'
  }, {
    q: 'Hoe ga je om met patiënten die angst voor de tandarts hebben?',
    a: "We adviseren een rustig, licht design met veel foto's van het team en de praktijk. Ook kunnen we een speciale pagina inrichten over angstbehandelingen."
  }]} data-id="element-1084" data-mp="1nhse6zwcn7x2" />;
}